// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faHome,
//   faPhone,
//   faUsers,
//   faUserGroup,
//   faChild,
//   faReceipt,
//   faImage,
//   faCheckCircle,
//   faCalendarDay,
//   faMapMarkerAlt,
//   faIndianRupeeSign,
//   faQrcode,
//   faCopy,
// } from "@fortawesome/free-solid-svg-icons";
// import PaymentQr from "../assets/QR.jpeg";
// const NewYear = () => {
//   const [formData, setFormData] = useState({
//     residentName: "",
//     flatNumber: "",
//     contactNumber: "",
//     totalMembers: "",
//     numberOfAdults: "",
//     numberOfChildren: "",
//     totalAmount: "",
//     paymentScreenshot: null,
//     utrNumber: "",
//   });

//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [showQR, setShowQR] = useState(false);

//   // Payment details
//   const paymentDetails = {
//     upiId: "gardeniagateway@upi",
//   };

//   const handleChange = (e) => {
//     const { name, value, type } = e.target;

//     if (type === "file") {
//       const file = e.target.files[0];
//       if (file) {
//         setFormData((prev) => ({ ...prev, [name]: file }));
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           setPreviewImage(reader.result);
//         };
//         reader.readAsDataURL(file);
//       }
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));

//       // Auto-calculate total amount
//       if (name === "numberOfAdults" || name === "numberOfChildren") {
//         const adults =
//           name === "numberOfAdults"
//             ? parseInt(value) || 0
//             : parseInt(formData.numberOfAdults) || 0;
//         const children =
//           name === "numberOfChildren"
//             ? parseInt(value) || 0
//             : parseInt(formData.numberOfChildren) || 0;
//         const total = adults * 300 + children * 150;
//         setFormData((prev) => ({ ...prev, totalAmount: total }));

//         // Show QR if amount is greater than 0
//         if (total > 0) {
//           setShowQR(true);
//         } else {
//           setShowQR(false);
//         }
//       }

//       // Auto-calculate total members
//       if (name === "numberOfAdults" || name === "numberOfChildren") {
//         const adults =
//           name === "numberOfAdults"
//             ? parseInt(value) || 0
//             : parseInt(formData.numberOfAdults) || 0;
//         const children =
//           name === "numberOfChildren"
//             ? parseInt(value) || 0
//             : parseInt(formData.numberOfChildren) || 0;
//         setFormData((prev) => ({ ...prev, totalMembers: adults + children }));
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//     setIsSubmitted(true);
//   };

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//     alert("Copied to clipboard!");
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 p-4 md:p-8">
//       <div className="max-w-4xl mx-auto">
//         {/* Header Banner */}
//         <div className="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 rounded-3xl p-6 md:p-8 mb-8 text-center shadow-2xl shadow-orange-200">
//           <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 flex items-center justify-center gap-3">
//             🎉 Welcoming New Year – Gardenia Gateway 🎉
//           </h1>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white text-lg">
//             <div className="flex items-center justify-center gap-2">
//               <FontAwesomeIcon icon={faCalendarDay} />
//               <span>December 31, 2025 at 8.00 PM onwards</span>
//             </div>
//             <div className="flex items-center justify-center gap-2">
//               <FontAwesomeIcon icon={faMapMarkerAlt} />
//               <span>Club House of Society</span>
//             </div>
//           </div>
//         </div>

//         {/* Pricing Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
//           <div className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-2xl p-6 transform hover:scale-[1.02] transition-transform duration-300">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
//                 <FontAwesomeIcon
//                   icon={faChild}
//                   className="text-white text-xl"
//                 />
//               </div>
//               <h3 className="text-xl font-bold text-blue-800">
//                 Children (5–12 years)
//               </h3>
//             </div>
//             <div className="flex items-baseline">
//               <span className="text-3xl font-bold text-blue-600 flex items-center">
//                 <FontAwesomeIcon
//                   icon={faIndianRupeeSign}
//                   className="text-xl mr-1"
//                 />
//                 150
//               </span>
//               <span className="text-gray-600 ml-2">per child</span>
//             </div>
//           </div>

//           <div className="bg-gradient-to-br from-purple-50 to-purple-100 border-2 border-purple-200 rounded-2xl p-6 transform hover:scale-[1.02] transition-transform duration-300">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center">
//                 <FontAwesomeIcon
//                   icon={faUserGroup}
//                   className="text-white text-xl"
//                 />
//               </div>
//               <h3 className="text-xl font-bold text-purple-800">
//                 Adults (Above 12 years)
//               </h3>
//             </div>
//             <div className="flex items-baseline">
//               <span className="text-3xl font-bold text-purple-600 flex items-center">
//                 <FontAwesomeIcon
//                   icon={faIndianRupeeSign}
//                   className="text-xl mr-1"
//                 />
//                 300
//               </span>
//               <span className="text-gray-600 ml-2">per person</span>
//             </div>
//           </div>
//         </div>

//         {/* Form Container */}
//         <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-6 md:p-8 mb-8">
//           {/* Contact Info */}
//           <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 mb-8 text-center">
//             <p className="text-green-700 font-medium">
//               Contact for more details:{" "}
//               <span className="font-bold">+91 98765 43210</span>
//             </p>
//           </div>

//           {isSubmitted ? (
//             <div className="text-center py-12">
//               <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
//                 <FontAwesomeIcon
//                   icon={faCheckCircle}
//                   className="text-white text-3xl"
//                 />
//               </div>
//               <h3 className="text-2xl font-bold text-gray-800 mb-3">
//                 Registration Successful!
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Your registration for the New Year event has been confirmed.
//               </p>
//               <div className="bg-gray-50 rounded-xl p-4 inline-block">
//                 <p className="text-gray-700">
//                   We'll send a confirmation to your contact number.
//                 </p>
//               </div>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="space-y-8">
//               {/* Personal Details Section */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 {/* Name */}
//                 <div className="group">
//                   <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                     <FontAwesomeIcon icon={faUser} className="text-amber-600" />
//                     Name of Resident
//                   </label>
//                   <input
//                     type="text"
//                     name="residentName"
//                     value={formData.residentName}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
//                     placeholder="Enter your full name"
//                     required
//                   />
//                 </div>

//                 {/* Flat Number */}
//                 <div className="group">
//                   <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                     <FontAwesomeIcon icon={faHome} className="text-amber-600" />
//                     Flat Number
//                   </label>
//                   <input
//                     type="text"
//                     name="flatNumber"
//                     value={formData.flatNumber}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
//                     placeholder="e.g., A-101"
//                     required
//                   />
//                 </div>
//               </div>

//               {/* Contact Number */}
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                   <FontAwesomeIcon icon={faPhone} className="text-amber-600" />
//                   Contact Number
//                 </label>
//                 <input
//                   type="tel"
//                   name="contactNumber"
//                   value={formData.contactNumber}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
//                   placeholder="+91 98765 43210"
//                   required
//                 />
//               </div>

//               {/* Family Members Section */}
//               <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-6">
//                 <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center gap-2">
//                   <FontAwesomeIcon icon={faUsers} />
//                   Family Members Details
//                 </h3>

//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                   {/* Total Members */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Total Number of Family Members Attending
//                     </label>
//                     <input
//                       type="number"
//                       name="totalMembers"
//                       value={formData.totalMembers}
//                       readOnly
//                       className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-center font-bold text-lg text-blue-600"
//                     />
//                   </div>

//                   {/* Adults */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                       <FontAwesomeIcon
//                         icon={faUserGroup}
//                         className="text-blue-500"
//                       />
//                       Number of Adults (Above 12 Years)
//                     </label>
//                     <input
//                       type="number"
//                       name="numberOfAdults"
//                       value={formData.numberOfAdults}
//                       onChange={handleChange}
//                       min="0"
//                       className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300 text-center"
//                       placeholder="0"
//                     />
//                     <div className="text-sm text-blue-600 font-medium mt-1">
//                       ₹{" "}
//                       {formData.numberOfAdults
//                         ? formData.numberOfAdults * 300
//                         : 0}
//                     </div>
//                   </div>

//                   {/* Children */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                       <FontAwesomeIcon
//                         icon={faChild}
//                         className="text-blue-500"
//                       />
//                       Number of Children (5–12 Years)
//                     </label>
//                     <input
//                       type="number"
//                       name="numberOfChildren"
//                       value={formData.numberOfChildren}
//                       onChange={handleChange}
//                       min="0"
//                       className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300 text-center"
//                       placeholder="0"
//                     />
//                     <div className="text-sm text-blue-600 font-medium mt-1">
//                       ₹{" "}
//                       {formData.numberOfChildren
//                         ? formData.numberOfChildren * 150
//                         : 0}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Payment Section - Only shown when amount > 0 */}
//               {showQR && (
//                 <div className="bg-gradient-to-r from-green-50 to-emerald-100 rounded-2xl p-6">
//                   <h3 className="text-lg font-bold text-green-800 mb-4 flex items-center gap-2">
//                     <FontAwesomeIcon icon={faQrcode} />
//                     Make Payment
//                   </h3>

//                   {/* Total Amount Display */}
//                   <div className="mb-6">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Total Amount to Pay (₹)
//                     </label>
//                     <div className="flex items-center">
//                       <div className="w-full px-4 py-4 bg-white border-2 border-green-500 rounded-xl text-center">
//                         <span className="text-3xl font-bold text-green-600 flex items-center justify-center">
//                           <FontAwesomeIcon
//                             icon={faIndianRupeeSign}
//                             className="text-2xl mr-1"
//                           />
//                           {formData.totalAmount || "0"}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="text-sm text-gray-600 mt-2 text-center">
//                       (Adults: {formData.numberOfAdults || 0} × ₹300 + Children:{" "}
//                       {formData.numberOfChildren || 0} × ₹150)
//                     </div>
//                   </div>

//                   {/* QR Code Section */}
//                   <div className="mb-6">
//                     <div className="bg-white rounded-2xl p-6 border border-green-200">
//                       <div className="text-center mb-4">
//                         <p className="text-sm font-medium text-gray-600 mb-2">
//                           Scan QR Code to Pay
//                         </p>
//                         <div className="inline-block p-4 bg-white border-2 border-green-300 rounded-xl">
//                           {/* Placeholder QR Code - Replace with actual QR image */}
//                           <div className="w-48 h-48 bg-gradient-to-br from-green-100 to-blue-100 flex items-center justify-center rounded-lg border-2 border-dashed border-green-400">
//                             <div className="text-center">
//                               <img src={PaymentQr} />
//                               <FontAwesomeIcon
//                                 icon={faQrcode}
//                                 className="text-6xl text-green-600 mb-2"
//                               />
//                               <p className="text-xs text-gray-600">
//                                 Payment QR Code
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* UPI ID */}
//                       <div className="mb-4">
//                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                           UPI ID
//                         </label>
//                         <div className="flex items-center gap-2">
//                           <div className="flex-1 bg-gray-50 border border-gray-300 rounded-lg px-4 py-2">
//                             <code className="text-green-700 font-medium">
//                               {paymentDetails.upiId}
//                             </code>
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               copyToClipboard(paymentDetails.upiId)
//                             }
//                             className="px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
//                           >
//                             <FontAwesomeIcon icon={faCopy} />
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* After Payment Details */}
//                   <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-200">
//                     <h4 className="text-lg font-bold text-blue-800 mb-3">
//                       After Payment
//                     </h4>

//                     {/* UTR Number Input */}
//                     <div className="mb-4">
//                       <label className="block text-sm font-semibold text-gray-700 mb-2">
//                         UTR / Transaction Number
//                       </label>
//                       <input
//                         type="text"
//                         name="utrNumber"
//                         value={formData.utrNumber}
//                         onChange={handleChange}
//                         className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300"
//                         placeholder="Enter UTR/Transaction number"
//                         required
//                       />
//                       <p className="text-xs text-gray-500 mt-1">
//                         Enter the UTR/Transaction ID from your payment
//                         confirmation
//                       </p>
//                     </div>

//                     {/* Payment Screenshot Upload */}
//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
//                         <FontAwesomeIcon
//                           icon={faImage}
//                           className="text-blue-600"
//                         />
//                         Upload Payment Screenshot
//                       </label>
//                       <div className="border-2 border-dashed border-blue-300 rounded-2xl p-6 text-center hover:border-blue-500 transition-colors duration-300 bg-white">
//                         <input
//                           type="file"
//                           name="paymentScreenshot"
//                           onChange={handleChange}
//                           accept="image/*"
//                           className="hidden"
//                           id="paymentScreenshot"
//                           required
//                         />
//                         <label
//                           htmlFor="paymentScreenshot"
//                           className="cursor-pointer"
//                         >
//                           <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                             <FontAwesomeIcon
//                               icon={faImage}
//                               className="text-blue-600 text-2xl"
//                             />
//                           </div>
//                           <p className="text-gray-600 mb-2">
//                             Upload payment confirmation screenshot
//                           </p>
//                           <p className="text-sm text-gray-500">
//                             Supports: JPG, PNG, GIF (Max 5MB)
//                           </p>
//                         </label>
//                       </div>

//                       {/* Preview */}
//                       {previewImage && (
//                         <div className="mt-4">
//                           <p className="text-sm font-medium text-gray-700 mb-2">
//                             Preview:
//                           </p>
//                           <img
//                             src={previewImage}
//                             alt="Payment Screenshot Preview"
//                             className="max-w-xs rounded-xl border border-gray-300"
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Submit Button */}
//               {showQR && (
//                 <button
//                   type="submit"
//                   className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold rounded-2xl shadow-lg shadow-green-500/30 hover:shadow-xl hover:shadow-green-500/40 hover:scale-[1.02] transition-all duration-300 text-lg"
//                 >
//                   Submit Registration
//                 </button>
//               )}

//               {/* Message when no payment needed */}
//               {!showQR &&
//                 formData.numberOfAdults === "" &&
//                 formData.numberOfChildren === "" && (
//                   <div className="text-center py-8">
//                     <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FontAwesomeIcon
//                         icon={faUsers}
//                         className="text-amber-600 text-2xl"
//                       />
//                     </div>
//                     <h3 className="text-xl font-bold text-gray-700 mb-2">
//                       Select number of attendees
//                     </h3>
//                     <p className="text-gray-600">
//                       Please select the number of adults and children above to
//                       proceed with payment
//                     </p>
//                   </div>
//                 )}
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewYear;

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHome,
  faPhone,
  faUsers,
  faUserGroup,
  faChild,
  faReceipt,
  faImage,
  faCheckCircle,
  faCalendarDay,
  faMapMarkerAlt,
  faIndianRupeeSign,
  faQrcode,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import PaymentQr from "../assets/QR.jpeg";
import WQR from "../assets/whQr.jpeg";
import axios from "axios";

const NewYear = () => {
  const [formData, setFormData] = useState({
    residentName: "",
    flatNumber: "",
    contactNumber: "",
    totalMembers: "",
    numberOfAdults: "",
    numberOfChildren: "",
    totalAmount: "",
    utrNumber: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Payment details
  const paymentDetails = {
    upiId: "parshan.kumar-4@oksbi",
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "file") {
      const file = e.target.files[0];
      if (file) {
        setFormData((prev) => ({ ...prev, [name]: file }));
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      // Auto-calculate total amount
      if (name === "numberOfAdults" || name === "numberOfChildren") {
        const adults =
          name === "numberOfAdults"
            ? parseInt(value) || 0
            : parseInt(formData.numberOfAdults) || 0;
        const children =
          name === "numberOfChildren"
            ? parseInt(value) || 0
            : parseInt(formData.numberOfChildren) || 0;
        const total = adults * 300 + children * 150;
        setFormData((prev) => ({ ...prev, totalAmount: total.toString() }));

        // Show QR if amount is greater than 0
        if (total > 0) {
          setShowQR(true);
        } else {
          setShowQR(false);
        }
      }

      // Auto-calculate total members
      if (name === "numberOfAdults" || name === "numberOfChildren") {
        const adults =
          name === "numberOfAdults"
            ? parseInt(value) || 0
            : parseInt(formData.numberOfAdults) || 0;
        const children =
          name === "numberOfChildren"
            ? parseInt(value) || 0
            : parseInt(formData.numberOfChildren) || 0;
        setFormData((prev) => ({
          ...prev,
          totalMembers: (adults + children).toString(),
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      // Create FormData object for multipart/form-data
      const submitFormData = new FormData();

      // Append all form fields as required by backend
      submitFormData.append("residentName", formData.residentName);
      submitFormData.append("flatNumber", formData.flatNumber);
      submitFormData.append("contactNumber", formData.contactNumber);
      submitFormData.append("totalMembers", formData.totalMembers);
      submitFormData.append("numberOfAdults", formData.numberOfAdults);
      submitFormData.append("numberOfChildren", formData.numberOfChildren);
      submitFormData.append("totalAmount", formData.totalAmount);
      submitFormData.append("utrNumber", formData.utrNumber);

      // Append the file if it exists

      // Make POST request to backend
      const response = await axios.post(
        "https://waapi.deetyasoft.com/api/user/addResident",
        submitFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response from server:", response.data);

      if (response.status === 200 || response.status === 201) {
        setIsSubmitted(true);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to submit registration. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard!");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 p-2 md:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Banner */}
        <div className="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 rounded-3xl p-6 md:p-8 mb-8 text-center shadow-2xl shadow-orange-200">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 flex items-center justify-center gap-3">
            🎉 Welcoming New Year – Gardenia Gateway
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white text-lg">
            <div className="flex items-center justify-center gap-2">
              <FontAwesomeIcon icon={faCalendarDay} />
              <span> 31st Dec 2025 at 6.30 PM onwards</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              Venue: <span> Gardenia Club House </span>
            </div>
     

          </div>
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl">
            <div className="flex items-center">
              <span className="font-medium">Error: </span>
              <span className="ml-2">{error}</span>
            </div>
            <button
              onClick={() => setError(null)}
              className="mt-2 text-sm text-red-600 hover:text-red-800"
            >
              Dismiss
            </button>
          </div>
        )}

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-2xl p-6 transform hover:scale-[1.02] transition-transform duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faChild}
                  className="text-white text-xl"
                />
              </div>
              <h3 className="text-xl font-bold text-blue-800">
                Children (5–12 years)
              </h3>
            </div>
            <div className="flex items-baseline">
              <span className="text-3xl font-bold text-blue-600 flex items-center">
                <FontAwesomeIcon
                  icon={faIndianRupeeSign}
                  className="text-xl mr-1"
                />
                150
              </span>
              <span className="text-gray-600 ml-2">per child</span>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 border-2 border-purple-200 rounded-2xl p-6 transform hover:scale-[1.02] transition-transform duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faUserGroup}
                  className="text-white text-xl"
                />
              </div>
              <h3 className="text-xl font-bold text-purple-800">
                Adults (Above 12 years)
              </h3>
            </div>
            <div className="flex items-baseline">
              <span className="text-3xl font-bold text-purple-600 flex items-center">
                <FontAwesomeIcon
                  icon={faIndianRupeeSign}
                  className="text-xl mr-1"
                />
                300
              </span>
              <span className="text-gray-600 ml-2">per person</span>
            </div>
          </div>
        </div>

        {/* Form Container */}
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-6 md:p-8 mb-8">
          {/* Contact Info */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 mb-8 text-center">
            <p className="text-green-700 font-medium">
              Contact for more details:{" "}
              <span className="font-bold">+91 9717055088</span>
            </p>
          </div>

          {isSubmitted ? (
            <div className="text-center py-12">
              <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="text-white text-3xl"
                />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Registration Successful!
              </h3>
              <p className="text-gray-600 mb-6">
                Your registration for the New Year event has been confirmed.
              </p>
              <div className="bg-gray-50 rounded-xl p-4 inline-block">
                <p className="text-gray-700">
                  We'll send a confirmation to your contact number.
                </p>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Personal Details Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Name */}
                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                    <FontAwesomeIcon icon={faUser} className="text-amber-600" />
                    Name of Resident
                  </label>
                  <input
                    type="text"
                    name="residentName"
                    value={formData.residentName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                {/* Flat Number */}
                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                    <FontAwesomeIcon icon={faHome} className="text-amber-600" />
                    Flat Number
                  </label>
                  <input
                    type="text"
                    name="flatNumber"
                    value={formData.flatNumber}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
                    placeholder="e.g., A-101"
                    required
                  />
                </div>
              </div>

              {/* Contact Number */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                  <FontAwesomeIcon icon={faPhone} className="text-amber-600" />
                  Contact Number
                </label>
                <input
                  type="tel"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none transition-all duration-300"
                  placeholder="+91 98765 43210"
                  required
                />
              </div>

              {/* Family Members Section */}
              <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-6">
                <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center gap-2">
                  <FontAwesomeIcon icon={faUsers} />
                  Family Members Details
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* Total Members */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Total Number of Family Members Attending
                    </label>
                    <input
                      type="number"
                      name="totalMembers"
                      value={formData.totalMembers}
                      readOnly
                      className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-center font-bold text-lg text-blue-600"
                    />
                  </div>

                  {/* Adults */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                      <FontAwesomeIcon
                        icon={faUserGroup}
                        className="text-blue-500"
                      />
                      Number of Adults (Above 12 Years)
                    </label>
                    <input
                      type="number"
                      name="numberOfAdults"
                      value={formData.numberOfAdults}
                      onChange={handleChange}
                      min="0"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300 text-center"
                      placeholder="0"
                      required
                    />
                    <div className="text-sm text-blue-600 font-medium mt-1">
                      ₹{" "}
                      {formData.numberOfAdults
                        ? formData.numberOfAdults * 300
                        : 0}
                    </div>
                  </div>

                  {/* Children */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                      <FontAwesomeIcon
                        icon={faChild}
                        className="text-blue-500"
                      />
                      Number of Children
                      <br />
                      (5–12 Years)
                    </label>
                    <input
                      type="number"
                      name="numberOfChildren"
                      value={formData.numberOfChildren}
                      onChange={handleChange}
                      min="0"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300 text-center"
                      placeholder="0"
                      required
                    />
                    <div className="text-sm text-blue-600 font-medium mt-1">
                      ₹{" "}
                      {formData.numberOfChildren
                        ? formData.numberOfChildren * 150
                        : 0}
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Section - Only shown when amount > 0 */}
              {showQR && (
                <div className="bg-gradient-to-r from-green-50 to-emerald-100 rounded-2xl p-3 md:p-6">
                  <h3 className="text-lg font-bold text-green-800 mb-4 flex items-center gap-2">
                    <FontAwesomeIcon icon={faQrcode} />
                    Make Payment
                  </h3>

                  {/* Total Amount Display */}
                  <div className="mb-6">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Total Amount to Pay (₹)
                    </label>
                    <div className="flex items-center">
                      <div className="w-full px-4 py-4 bg-white border-2 border-green-500 rounded-xl text-center">
                        <span className="text-3xl font-bold text-green-600 flex items-center justify-center">
                          <FontAwesomeIcon
                            icon={faIndianRupeeSign}
                            className="text-2xl mr-1"
                          />
                          {formData.totalAmount || "0"}
                        </span>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 mt-2 text-center">
                      (Adults: {formData.numberOfAdults || 0} × ₹300 + Children:{" "}
                      {formData.numberOfChildren || 0} × ₹150)
                    </div>
                  </div>

                  {/* QR Code Section */}
                  <div className="mb-6">
                    <div className="bg-white rounded-2xl p-3 md:p-6 border border-green-200">
                      <div className="text-center mb-4">
                        <p className="text-sm font-medium text-gray-600 mb-2">
                          Scan QR Code to Pay
                        </p>
                        <div className="inline-block p-4 bg-white border-2 border-green-300 rounded-xl">
                          <div className="w-48 h-48 flex items-center justify-center rounded-lg">
                            <img
                              src={PaymentQr}
                              alt="Payment QR Code"
                              className="w-full h-full object-contain rounded-lg"
                            />
                          </div>
                        </div>
                      </div>

                      {/* UPI ID */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          UPI ID
                        </label>
                        <div className="flex items-center gap-2">
                          <div className="flex-1 bg-gray-50 border border-gray-300 rounded-lg px-1 md:px-4 py-2">
                            <code className="text-green-700 font-medium">
                              {paymentDetails.upiId}
                            </code>
                          </div>
                          <button
                            type="button"
                            onClick={() =>
                              copyToClipboard(paymentDetails.upiId)
                            }
                            className="px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                          >
                            <FontAwesomeIcon icon={faCopy} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* After Payment Details */}
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl  p-3 md:p-6 border border-blue-200">
                    <h4 className="text-lg font-bold text-blue-800 mb-3">
                      After Payment
                    </h4>

                    {/* UTR Number Input */}
                    <div className="mb-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        UTR / Transaction Number *
                      </label>
                      <input
                        type="text"
                        name="utrNumber"
                        value={formData.utrNumber}
                        onChange={handleChange}
                        className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-300"
                        placeholder="Enter UTR/Transaction number"
                        required
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Enter the UTR/Transaction ID from your payment
                        confirmation
                      </p>
                    </div>

                    <div className=" bg-black text-white flex items-center justify-center">
                      <div className="max-w-4xl w-full bg-gray-900 rounded-2xl p-3 shadow-lg border border-gray-700">
                        {/* Header */}
                        <h2 className="text-xl font-bold text-center mb-6">
                          Payment & Support Section
                        </h2>

                        {/* Content Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                          {/* WhatsApp Section */}
                          <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
                            <h3 className="text-xl font-semibold mb-3">
                              Contact on WhatsApp
                            </h3>

                            <img
                              src={WQR}
                              alt="WhatsApp"
                              className="w-56 object-contain mx-auto "
                            />
                          </div>
                          <div>
                            <p className="  text-center text-green-400 text-xl mt-2">
                              📞 WhatsApp: 9717055088
                            </p>

                            <button
                              onClick={() =>
                                window.open(
                                  "https://wa.me/9717055088",
                                  "_blank"
                                )
                              }
                              className="w-full px-2 mt-4 bg-green-500 hover:bg-green-600 py-2 rounded-lg text-black font-semibold"
                            >
                              Chat on WhatsApp (9717055088)
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Submit Button */}
              {showQR && (
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold rounded-2xl shadow-lg shadow-green-500/30 hover:shadow-xl hover:shadow-green-500/40 hover:scale-[1.02] transition-all duration-300 text-lg disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center">
                      <svg
                        className="animate-spin h-5 w-5 mr-3 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Submitting...
                    </div>
                  ) : (
                    "Submit Registration"
                  )}
                </button>
              )}

              {/* Message when no payment needed */}
              {!showQR &&
                formData.numberOfAdults === "" &&
                formData.numberOfChildren === "" && (
                  <div className="text-center py-8">
                    <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <FontAwesomeIcon
                        icon={faUsers}
                        className="text-amber-600 text-2xl"
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-700 mb-2">
                      Select number of attendees
                    </h3>
                    <p className="text-gray-600">
                      Please select the number of adults and children above to
                      proceed with payment
                    </p>
                  </div>
                )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewYear;
